import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TEAM_NAME } from '../../../../common/constants.tsx';
import { fetchArticleGenerationForTopics as fetchArticleGenerationForTopicsService } from '../../../../services/fetch-article-generation/index.tsx';

export const triggerArticleGenerationForTopics =
	(projectId: number, analyticsEvent: UIAnalyticsEvent, activationId: string) =>
	async (): Promise<void> => {
		try {
			await fetchArticleGenerationForTopicsService(projectId, activationId);

			fireTrackAnalytics(analyticsEvent, 'triggerArticleGenerationForTopics succeeded', {
				projectId,
			});

			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'triggerArticleGenerationForTopics',
					packageName: 'jiraServicedeskKnowledgePerformance',
					teamName: TEAM_NAME,
				},
				error,
			});
		}
	};
